
import React from 'react';
import { Alert, AlertDescription } from '@/components/ui/alert';

interface TermsAlertProps {
  isPage1: boolean;
  isTermsAccepted: boolean;
}

export const TermsAlert: React.FC<TermsAlertProps> = ({ isPage1, isTermsAccepted }) => {
  if (!isPage1 || isTermsAccepted) return null;
  
  return (
    <Alert className="mt-4 mb-2 bg-amber-50 border-amber-200">
      <AlertDescription>
        กรุณายอมรับเงื่อนไขก่อนดำเนินการต่อ
      </AlertDescription>
    </Alert>
  );
};

interface AbsentStudentAlertProps {
  isPage2: boolean;
  isStudentAbsent: boolean;
}

export const AbsentStudentAlert: React.FC<AbsentStudentAlertProps> = ({ isPage2, isStudentAbsent }) => {
  if (!isPage2 || !isStudentAbsent) return null;
  
  return (
    <Alert className="mt-4 mb-2 bg-blue-50 border-blue-200">
      <AlertDescription>
        เนื่องจากน้องไม่เข้าเรียน คุณสามารถส่งแบบฟอร์มได้เลย แต่ต้องกรอกข้อมูลที่จำเป็นให้ครบก่อน
      </AlertDescription>
    </Alert>
  );
};
